import store from '../../../../store';
export default function checkIfCanDestroy() {
  let exists = false;
  let scopes = store.getters.userScopes;
  if (
    scopes.includes('user_account_credentials_destroy_company') ||
    scopes.includes('user_account_credentials_destroy_all') ||
    scopes.includes('user_account_credentials_destroy_self')
  ) {
    exists = true;
  }
  return exists;
}
